<template>
  <div class="block" ref="extraDetailsContainer" v-if="showedServices.length">
    <button class="additional-options" @click="toggleWindow">
      <div class="title" :class="{ open: isExtraServicesVisible }">
        <img src="/images/redesignedForm/additional.svg" alt="additional" />
        <span class="heading">Дополнительные услуги</span>
        <img src="/images/redesignedForm/additional.svg" alt="additional" />
      </div>
      <div class="description">
        <span>{{ servicesNamesShortList }}...</span>
      </div>
    </button>
    <transition name="smooth-render">
      <div class="block services" v-if="isExtraServicesVisible">
        <ul class="services-list">
          <li v-for="service in showedServices" :key="service.id" class="service-item">
            <div class="info" :class="{ disabled: !service.isAvailable }">
              <div class="label" @click="service.isAvailable ? localToggleService(service) : null">
                <input
                  :disabled="!service.isAvailable"
                  type="checkbox"
                  :checked="addedServicesID.includes(service.id)"
                />
                <span>{{ service.name }}</span>
              </div>
              <div class="price">
                <span>{{ service.price }} &#x20bd;</span>
                <i
                  class="icon-tooltip"
                  v-tooltip.top-center="{
                    content: service.description,
                    trigger: 'click hover',
                  }"
                ></i>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import { GENERAL_STORE } from '@apps/order-form/src/store'

export default {
  name: 'ExtraServicesAnonimous',
  data: () => ({
    isExtraServicesVisible: false,
  }),
  computed: {
    ...mapState(GENERAL_STORE, ['services', 'base', 'form']),
    ...mapGetters(GENERAL_STORE, ['showedServices', 'addedServicesID', 'managedServices']),
    servicesNamesShortList() {
      return this.showedServices
        .slice(0, 3)
        .map(service => service.name)
        .join(', ')
    },
  },
  methods: {
    ...mapMutations(GENERAL_STORE, ['toggleService']),
    ...mapActions(GENERAL_STORE, ['calculatePrice']),
    localToggleService(service) {
      this.toggleService(service.id)

      this.calculatePrice()
    },
    toggleWindow() {
      this.isExtraServicesVisible = !this.isExtraServicesVisible
    },
  },
}
</script>

<style lang="scss" scoped>
.info.disabled {
  opacity: 0.4;

  .label {
    cursor: default;

    input {
      cursor: default !important;
    }

    span {
      cursor: default;
    }
  }
}

.smooth-render-enter,
.smooth-render-leave-to {
  transform: scale(0);
}

.smooth-render-enter-to,
.smooth-render-leave {
  transform: scale(1);
}

.smooth-render-enter-active,
.smooth-render-leave-active {
  transition: opacity, 0.3s linear;
  transition: transform 0.3s linear;
}

.heading {
  font-weight: 700;
}

.services {
  margin-top: 20px;
}
</style>
